<template>
  <div>
   <!-- <headerLoginNoMenu></headerLoginNoMenu> -->
    <div class="bg-gradient-gray">
        <bannerVideo :contentId = courseId></bannerVideo>

        <div class="content-holder">
            <!-- <instructorProfile></instructorProfile>

            <courseObjectives></courseObjectives> -->
            <!-- <courseList></courseList> -->
            <!-- <courseReview></courseReview> -->

            <!-- <div class="text-center section-holder">
                 <button class="btn btn-blue btn-large mb-2 mr-3">Buy now</button>
                 <button class="btn btn-purple btn-large mb-2">Add to cart</button>
            </div> -->
        </div>
    </div>
    <div class="content-holder">
        <!-- <courseCards></courseCards> -->
        <libraryCards></libraryCards>
    </div>
    <!-- <footerArea></footerArea> -->
</div>
</template>

<script>
// import {EventBus} from '@/main.js'
import footerArea from '../common/footerArea.vue'
import bannerVideo from './bannerVideo.vue'
import instructorProfile from '../profile/instructorProfile.vue'
import courseObjectives from './courseObjectives.vue'
import courseList from './courseList.vue'
import courseReview from './courseReview'
import courseCards from '../home/courseCards'
import libraryCards from '../home/libraryCards'
import { EventBus } from '@/main.js'

export default {
  name: 'coursePage',
  data () {
    return {
      courseId: ''
    }
  },
  components: {
    footerArea,
    bannerVideo,
    instructorProfile,
    courseObjectives,
    courseList,
    courseReview,
    courseCards,
    libraryCards
  },
  mounted () {
    EventBus.$emit('showNav', false)
    // alert(JSON.stringify(this.$store.getters.getCurrentCourse))
  },
  created () {
    this.courseId = this.$route.params.contentId
    // console.log(this.$route.params.id)
    // alert(this.$route.params.id)
  }
}
</script>
<style lang="scss">
.bg-gradient-gray{
        // background: linear-gradient(to top, #f0f0f0 50%,#ffffff 100%); 
}
// .tags-nav{
//     padding:20px 0 10px 0;
//     @mixin tags-css($color, $colorText) {
//         margin-right:5px;
//         display: inline-block;
//         margin-bottom:10px;
//         cursor: pointer;
//         color: $colorText;
//         border-radius: 2px;
//         padding: 4px 15px;
//         background-color: $color;
//         font-weight:600; 
//         .tag-css-text{
//             padding-right:5px;
//         }
//         .tag-css-x{
//             border-radius: 2px;
//             font-weight: 200;
//             padding:4px 10px;
//             background-color: darken($color, 9%);
//             &:hover{
//                 background-color: darken($color, 15%);    
//             }
//         }
//     }
//     .tags-back{@include tags-css(transparent, #333); span{padding-left:5px;  text-transform: capitalize;} &:hover{color:#000;}}
//     .tag-css-select-category{ @include tags-css(#26b9e3, #fff);}
//     .tag-css-unselect-category { @include tags-css(#e3e3e3,#333);  &:hover{ @include tags-css(#26b9e3, #fff);} }
//     .tag-css-select-topic { @include tags-css(#3E62BE, #fff); }
//     .tag-css-unselect-topic { @include tags-css(#e3e3e3,#333);  &:hover{ @include tags-css(#3E62BE, #fff);} }
// }
</style>




// WEBPACK FOOTER //
// src/components/course/coursePage.vue?1ea9121e